import * as __ from 'lodash';
import '../typeValidation/booking.js';
import { nullishFilter } from '../typeValidation/nullish.js';
import '../typeValidation/draftWaypoint.js';
import '../typeValidation/feedback.js';
import '../environment/crypto/index.js';
import 'dayjs';
import '@caresend/types';
import 'immutability-helper';
import 'lodash-unified';
import './string.js';
import 'ngeohash';
import './location.js';
import '../initializers/user.js';
import '../typeValidation/note.js';
import '../typeValidation/procedure.js';
import '../typeValidation/samples.js';
import '../typeValidation/shift.js';
import '../typeValidation/shipmentInfo.js';
import '../typeValidation/supply.js';
import '../typeValidation/timeSlot.js';
import '../typeValidation/waypoint.js';
import '../typeValidation/waypointAction.js';

const {
  isEqual
} = __;
/**
 * Create an array from a total number and a batch size.
 *
 * Example:
 * - (16, 5) => [0, 5, 10, 15, 16]
 */

const createBatchArray = (totalAmount, batchSize) => {
  const batchArray = [0];
  let currentBatch = batchSize;

  while (currentBatch < totalAmount) {
    batchArray.push(currentBatch);
    currentBatch += batchSize;
  }

  if (currentBatch > totalAmount) {
    batchArray.push(totalAmount);
  } else {
    batchArray.push(currentBatch);
  }

  return batchArray;
};
/**
 * Slice an array into a number of parts.
 *
 * Returns `n` arrays distributed as equally as possible in the output
 * (['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'], 2) => [['sun', 'mon', 'tue', 'wed'], ['thu', 'fri', 'sat']]
 * (['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'], 3) => [['sun', 'mon', 'tue'], ['wed', 'thu'], ['fri', 'sat']]
 * (['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'], 4) => [['sun', 'mon'], ['tue', 'wed'], ['thu', 'fri'], ['sat']]
 */

const sliceArrayIntoParts = (arr, numberOfParts) => {
  const {
    length
  } = arr;
  const partSize = Math.floor(length / numberOfParts);
  const remainder = length % numberOfParts;
  let start = 0;
  return Array.from({
    length: numberOfParts
  }, (_, index) => {
    const end = start + partSize + (index < remainder ? 1 : 0);
    const slice = arr.slice(start, end);
    start = end;
    return slice;
  });
};
/**
 * Returns the intersection of multiple arrays.
 * [[1,2,3], [2,3,4,5]] -> [2,3]
 * [
      [{ test: 1 }, { test: 2 }, { test: 5 }],
      [{ test: 4 }, { test: 5 }],
      [{ test: 2 }, { test: 5 }],
    ] -> [{ test: 5 }]
 */

const getIntersection = arrayOfArrays => {
  var _a, _b;

  return (_b = (_a = arrayOfArrays.reduce((intersection, currentArray) => intersection === null || intersection === void 0 ? void 0 : intersection.filter(value => currentArray.some(obj => isEqual(obj, value))), arrayOfArrays[0])) === null || _a === void 0 ? void 0 : _a.filter(nullishFilter)) !== null && _b !== void 0 ? _b : [];
};
const hasIntersection = arrayOfArrays => getIntersection(arrayOfArrays).length > 0;

export { createBatchArray, getIntersection, hasIntersection, sliceArrayIntoParts };
